import React from 'react';

const ChatClients =()=>{
    return(
        <section className="chat_get_started_area">
            <div className="container">
                <div className="chat_get_started_content text-center">
                    <h2 className="wow fadeInUp" data-wow-delay="0.2s">Und, wie lässt sich die Lösung integrieren?</h2>
                    <p>
                        Lassen Sie uns darüber reden! Wir finden einen Weg, um Ihre Prozesse optimal zu unterstützen. 
                    </p>
                </div>
            </div>
        </section>
    )
}
export default ChatClients;
